import { Suspense } from 'react';
import { Loading } from './loading';
import AnimatedFadeInComponent from '@/components/AnimatedFadeInComponent';
import {
  FETCH_MISSIONS,
  HomePage,
  Mission,
  MissionsListQuery,
  MissionsListQueryVariables,
} from '@edwin-group/cj-graphql';
import { Link } from 'react-router-dom';
import { getSchoolContext } from '@/hooks/useAuthentication';
import { useSuspenseQuery } from '@apollo/client';
import { GetCurrentSchoolYearUseCase } from '@/pages/mission/use-cases/get-current-school-year';
import { Card } from '@/pages/mission/listing/components/card';
import FieldError from '@/components/FieldError';

export const MissionsComponent = ({ page }: { page: HomePage }) => {
  const { title, viewAll: viewAllText } = page?.missionSection || {};
  const viewAllUrl = '/missions';

  const { data: missionsListResult, error: missionsListError } = useSuspenseQuery<
    MissionsListQuery,
    MissionsListQueryVariables
  >(FETCH_MISSIONS, {
    variables: {
      sort: 'publishedAt:asc',
      pagination: { start: 0, limit: 3 },
      schoolDocumentId: getSchoolContext()?.documentId || '',
      schoolYear: GetCurrentSchoolYearUseCase.execute(),
    },
  });

  const viewAll = (missionsListResult?.fetchMissionsBySchoolAndSchoolYear?.nodes?.length || 0) > 2;

  if (missionsListError) {
    return <FieldError message={missionsListError.message} />;
  }

  if (missionsListResult?.fetchMissionsBySchoolAndSchoolYear?.nodes?.length === 0) {
    return <div>No missions found</div>;
  }

  return (
    <AnimatedFadeInComponent fromBottom>
      <div>
        <div className="flex items-center justify-between">
          <h3 className="mb-sh-15 font-cadiz text-sh-28-32 font-bold">{title}</h3>
          {viewAll ? (
            <Link className="text-sh-xxxs font-bold text-primary-600" to={viewAllUrl}>
              {viewAllText}
            </Link>
          ) : null}
        </div>
        <div className="grid grid-cols-1 gap-sh-15 md:grid-cols-2 lg:grid-cols-3">
          {missionsListResult?.fetchMissionsBySchoolAndSchoolYear?.nodes?.map((mission) => {
            return <Card mission={mission as Mission} key={mission?.documentId} />;
          })}
        </div>
      </div>
    </AnimatedFadeInComponent>
  );
};

export function Missions({ page }: { page: HomePage }) {
  return (
    <Suspense fallback={<Loading />}>
      <MissionsComponent page={page} />
    </Suspense>
  );
}
